import { FormattedMessage } from "react-intl";
import { Button, Heading, Text } from "@lendcord/concord";

// TODO: this is a placeholder number — swap for the real support line once confirmed.
const SUPPORT_PHONE = "+91 98765 43210";

function handleRequestCallback() {
  // TODO: wire to the real callback-request flow once it's built.
}

export function SupportCard() {
  return (
    <div className="rounded-md border border-border bg-surface-raised p-6 shadow-sm">
      <Heading level={3} className="mb-1">
        <FormattedMessage id="lender.supportCard.title" />
      </Heading>
      <Text size="sm" variant="muted" className="mb-2">
        <FormattedMessage id="lender.supportCard.description" />
      </Text>
      <Text size="sm" className="font-medium text-accent-600">
        support@lendcord.in
      </Text>
      <Text size="sm" className="mt-2 font-medium text-text">
        <FormattedMessage id="lender.supportCard.phoneLabel" values={{ phone: SUPPORT_PHONE }} />
      </Text>
      <Button type="button" variant="link" onClick={handleRequestCallback} className="mt-2">
        <FormattedMessage id="lender.supportCard.callBackButton" />
      </Button>
    </div>
  );
}
